import {
  Card,
  Typography,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowBackIos, tpTheme } from "@trainingpeaks/designtokens";
import { usePaymentMethodContext } from "@context/PaymentMethodContext";
import PaymentMethodCard from "@components/PaymentMethods/PaymentMethodCard";
import useHandleAddCard from "@hooks/useHandleAddCard";
import useManagePaymentMethods from "@hooks/useManagePaymentMethods";

const PaymentMethodsContainer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    paymentMethods,
    arePaymentMethodsLoading,
    error,
  } = usePaymentMethodContext();

  const {
    handleAddCard,
    handleMakePrimary,
    handleDelete,
  } = useManagePaymentMethods();

  const { handleAddCardModalOpen, modal: addCardModal } = useHandleAddCard(handleAddCard);

  if (arePaymentMethodsLoading) {
    return (
      <Box className="flex justify-center py-8">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" variant="body2">
        {t("Error loading payment methods")}
      </Typography>
    );
  }

  return (
    <Box className="max-w-3xl" data-testid="payment-methods-container">
      <Button
        variant="text"
        color="primary"
        startIcon={<ArrowBackIos size="16" fill={tpTheme.semanticLayer.colors.primary.main} />}
        onClick={() => navigate("/subscriptions")}
        className="mb-4"
        data-testid="back-to-subscriptions"
      >
        {t("Subscriptions")}
      </Button>
      {paymentMethods.length > 0 && (
        <Box className="flex flex-col gap-4 mb-4">
          {paymentMethods.map((pm) => (
            <Card key={pm.id} className="rounded-lg">
              <PaymentMethodCard
                paymentMethod={pm}
                onMakePrimary={() => handleMakePrimary(pm.id)}
                onDelete={() => handleDelete(pm.id)}
              />
            </Card>
          ))}
        </Box>
      )}
      <Button
        variant="outlined"
        className="rounded-full"
        onClick={handleAddCardModalOpen}
        data-testid="add-card-button"
      >
        {t("Add Card")}
      </Button>
      {addCardModal}
    </Box>
  );
};

export default PaymentMethodsContainer;
